import { Box } from '@mui/material';
import { useEffect, useState } from 'react';
import { API_GET, DBRequest, useConfig } from '../../api/api';
import ExoTable from '../exo/ExoTable';
import { useTranslation } from 'react-i18next';
import ExoProcessing from '../exo/ExoProcessing';

const SelectContractTemplate = ({ onSelect, type }) => {
  const { t } = useTranslation();

  // request
  const [presets, setPresets] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [isProcessing, setIsProcessing] = useState(false);
  const config = useConfig();
  useEffect(() => {
    if (!config) return;
    DBRequest({
      config,
      path: `contractpresets?category[eq]=${type}`,
      method: API_GET,
      onResponse: setPresets,
      onLoading: setIsLoading,
    });
  }, [config]);

  function handleSelect(row) {
    DBRequest({
      config,
      path: `contractpresets/${row.id}`,
      onResponse: (res) => {
        onSelect(res.data);
      },
      onLoading: setIsProcessing,
    });
  }

  // tabel
  const columns = [
    {
      header: t('Nr'), // header of column
      key: 'id', // key of column in row-object
      thAlign: 'center', // header text alignment
      tdAlign: 'center', // cell text alignment
      sortable: true, // enable sort function for column
      width: '50px', // width of column
      onClick: (row) => handleSelect(row),
    },
    {
      header: t('Title'), // header of column
      key: 'title', // key of column in row-object
      thAlign: 'left', // header text alignment
      tdAlign: 'left', // cell text alignment
      sortable: true, // enable sort function for column
      onClick: (row) => handleSelect(row),
    },
  ];

  return (
    <>
      <Box className=" flex flex-col gap-2 h-full overflow-y-auto pr-2">
        <ExoTable columns={columns} data={presets} isLoading={isLoading} />
      </Box>
      <ExoProcessing open={isProcessing} label={t('Loading Contract')} />
    </>
  );
};

export default SelectContractTemplate;
